import React from 'react';

import { ISearchFilter, ISearchFilterRangeOption } from '../../../../../context/search/types';

import useSearch from '../../../../../context/search/useSearch';
import Money from '../../../../Money';
import DualRangeSlider from '../../../../RangeSliders/DualRangeSlider';

interface IMultiOptionFilter {
  filterIndex: number,
  filter: ISearchFilter,
}

/*
 *
 * @param filterIndex
 * @param filter
 * @constructor
 */


const RangeOptionFilter: React.FC<IMultiOptionFilter> = ({filterIndex, filter}): JSX.Element => {

  const { inputEventHandlers, markFiltersChanged } = useSearch()

  const onChangeHandler = (vals: [number, number], index: number) => {
    inputEventHandlers.handleUpdateRangeOption(filterIndex, index, vals[0], vals[1]);
    // Defer committing range changes to URL/search until Apply is clicked
    markFiltersChanged();
  }

  if (!filter.open) return <></>

  return (
    <div className={'filter__options filter__options--range'}>
      <div className={'filter__items filter__items--range'}>
        {
          (filter.options as ISearchFilterRangeOption[]).map((option: ISearchFilterRangeOption, index) => {
            return (
              <DualRangeSlider
                key={index}
                range={[option.minimum, option.maximum]}
                values={[option.selectedMinimum, option.selectedMaximum]}
                onChange={(vals) => onChangeHandler(vals, index)}>
                {({ value, labelHandle }) => <span><label>{ labelHandle }: </label><Money amount={value * 100} /></span>}
              </DualRangeSlider>
            )
          })
        }
      </div>
    </div>
  )
}

export default RangeOptionFilter